import makeStyles from '@mui/styles/makeStyles';
import TreeItem from '@mui/lab/TreeItem';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import React from 'react';

import {IconMap} from 'common/icons';

type TreeViewItemProps = {
   data: INav;
   style?: React.CSSProperties;
};

const useStyles = makeStyles((theme) => ({
   root: {
      padding: 0,
   },
   content: {
      height: '100%',
      padding: 0,
      background: theme.palette.background.default,
      marginLeft: 1,
      '.isActiveRoute &': {
         backgroundColor: theme.palette.action.selected,
      },
   },
   labelRoot: {
      display: 'flex',
      alignItems: 'center',
   },
   labelIcon: {
      marginRight: '5px',
      height: '1.3rem',
   },
   link: {
      flex: '1',
      display: 'block',
      whiteSpace: 'nowrap',
      padding: theme.spacing(1, 2),
      '& > *': {
         whiteSpace: 'nowrap',
         verticalAlign: 'middle',
      },
   },
   iconContainer: {
      '&&&': {
         width: 0,
         marginRight: 0,
      },
   },
}));

const TreeViewItem = ({data, style}: TreeViewItemProps) => {
   const classes = useStyles();

   return (
      <TreeItem
         style={style}
         key={data.id}
         classes={{
            root: classes.root,
            content: classes.content,
            iconContainer: classes.iconContainer,
         }}
         nodeId={String(data.id)}
         label={
            // <Link
            //    variant="body2"
            //    color="inherit"
            //    underline="none"
            //    component={RouterLink}
            //    to={`/${data.id}`}
            //    className={classNames(classes.link)}
            // >
            <div className={classes.link}>
               <img src={IconMap[data.objectType!]} alt="icon" className={classes.labelIcon} />
               {/* <DiplomatStateStatusIcon name={data.name} folderId={data.folderId} /> */}
               <span>{data.name}</span>
            </div>
            // </Link>
         }
      />
   );
};

export default React.memo(TreeViewItem);
